import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{staticClass:"ma-2 white--text",attrs:{"x-small":"","color":"primary","fab":""}},[_vm._v("+1")])}
var staticRenderFns = []

export { render, staticRenderFns }